import { useState, useEffect } from 'react';
import { Topic } from '../types/topics';
import apiClient from '../api/client';

export const useTopics = () => {
  const [data, setData] = useState<Topic[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const response = await apiClient.get('/api/v1/topics');
        setData(response.data.data);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch topics'));
      } finally {
        setIsLoading(false);
      }
    };

    fetchTopics();
  }, []);

  return { data, isLoading, error };
};